"use strict";

class DeveloperReportsHistoryController {

    constructor($scope, $timeout, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService, SSDateService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSDateService = SSDateService;

        self.data = SHOWSUITE.data;
        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        // WEB-4407: the status families a report's Download popup can offer, copied from
        // DeveloperReportsController so a history row can be labelled with the status it
        // was generated with. Status ids are unique only WITHIN a family - id 2 is URA
        // "Sold" and is not a sale status - so a label is only ever read from the family
        // the row's own report uses. See getStatusFamily().
        self.allReportStatus = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 30,
                name: 'OTP Issued'
            },
            {
                id: 32,
                name: 'SPA Issued'
            },
            {
                id: 37,
                name: 'Exercised'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.optionIssuedReportStatuses = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 51,
                name: 'OTP Issued'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.uraReportStatuses = [
            {
                id: 1,
                name: 'All'
            },
            {
                id: 2,
                name: 'Sold'
            },
            {
                id: 3,
                name: 'Aborted'
            },
            {
                id: 4,
                name: 'Re-issue'
            }
        ];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.setPageOptions();
        self.initFilters();

        self.$timeout(function () {
            $("select.dashboard-select").niceSelect('update');
            jQuery('.datepicker2').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });

        self.getProperties();
        self.getAllReports();
        self.getReportHistory(self.pageNo);
        // self.getDeveloperUsers();
        // self.getDeveloper();
    }

    getReportHistory(page) {
        const self = this;

        self.reports_history = null;

        if (page) {
            self.current = page;
        }
        self.filters.offset = (page * self.filters.limit) - self.filters.limit;

        let url = 'sec/developer/reports-history';
        let params = angular.copy(self.filters);
        params.from_date = self.toServerDate(self.filters.from_date);
        params.to_date = self.toServerDate(self.filters.to_date);

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reports_history = response.data.reports_history;
            self.users = response.data.users;
            self.total_count = response.data.count;

            // One-time normalisation of the raw payload. `downloadReportHistory()` needs
            // the comma-separated string as well as the split list, and property_ids is
            // nullable on report_histories (reports such as User Sessions carry none).
            self.reports_history.forEach(function (report) {
                report.url_properties = report.property_ids;
                report.property_ids = report.property_ids ? report.property_ids.split(',') : [];
                report.created_by_name = self.getUserDisplayName(report.created_by);
                report.created_at = self.toLocalDate(report.created_at)
            });

            self.decorateReportsHistory();
            self.prepareHistoryPaginationData();
        });
    }

    /**
     * WEB-4407: fill in everything a history row shows that is not stored on the row -
     * the report code, the project names and the status label.
     *
     * @remarks The rows, the project list and the report catalogue arrive from three
     *     independent requests and any of them can resolve first, so this is invoked
     *     from all three callbacks and must stay idempotent. It only ever writes the
     *     three derived fields; the one-time reshaping of the raw payload (splitting
     *     property_ids, localising created_at) stays in getReportHistory().
     * @returns {void}
     */
    decorateReportsHistory() {
        const self = this;

        if (!self.reports_history) {
            return;
        }

        self.reports_history.forEach(function (report) {
            let catalogueReport = self.getCatalogueReport(report);

            report.report_code = catalogueReport ? catalogueReport.code : null;
            report.display_title = report.report_code
                ? report.name + ' - ' + report.report_code
                : report.name;
            report.property_names = self.getPropertyNames(report);
            report.status_label = self.getStatusLabel(report, catalogueReport);
        });
    }

    /**
     * Names of the projects a history row was generated for.
     *
     * @param {Object} report A report_histories row, property_ids already split.
     * @returns {string} Comma-separated project names, or '' when the row carries no
     *     project ids or the project list has not arrived yet - an empty string hides
     *     the line rather than flashing a row of placeholders, and
     *     decorateReportsHistory() runs again once the list is in.
     */
    getPropertyNames(report) {
        const self = this;

        if (!report.property_ids || !report.property_ids.length) {
            return '';
        }
        if (!self.properties || !self.properties.length) {
            return '';
        }

        let propertyNames = [];
        report.property_ids.forEach(function (property_id) {
            propertyNames.push(self.getPropertyName(property_id));
        });

        return propertyNames.join(', '); // Join property names with comma and space
    }

    /**
     * The reports catalogue, needed to resolve a history row's code and status label.
     *
     * @remarks A 403 here is swallowed on purpose. This page is gated on
     *     DMS_REPORTS_HISTORY_VIEW but `sec/super/reports` requires DMS_REPORTS_VIEW,
     *     so a user can legitimately be allowed to read the history without being
     *     allowed to read the catalogue. Such a user should see the list unchanged,
     *     not an error banner over it, so the page degrades to rows with no code and
     *     no status instead of reporting the failure.
     * @returns {void}
     */
    getAllReports() {
        const self = this;

        self.reports = null;

        let url = 'sec/super/reports';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                return; // Degrade to name-only rows - see @remarks above.
            }

            self.reports = response.data ? response.data.reports : null;

            self.decorateReportsHistory();
        });
    }

    /**
     * Resolves a history row back to its catalogue report.
     *
     * report_histories stores no report id, so the match has to be made on what it does
     * store. The stored url is the catalogue's own `reports.url` with an environment
     * base in front, which makes the url path the only reliable key: an exact path match
     * first, then a segment-bounded suffix match for rows written against a different
     * base. The saved name is a last resort - it is the developer_reports alias, which
     * is free text and can name a different report than the row actually points at
     * (WEB-4019).
     *
     * @remarks An ambiguous match resolves to null rather than picking one. The
     *     catalogue really does hold several reports on one url (R057 and URA3_ both
     *     sit on /api/reports/ura-report), and a wrong code is worse than no code.
     * @param {Object} report A report_histories row.
     * @returns {Object|null} The catalogue report, or null when it cannot be resolved.
     */
    getCatalogueReport(report) {
        const self = this;

        if (!self.reports || !self.reports.length || !report) {
            return null;
        }

        self.setReportsIndex();

        let historyPath = self.reportUrlPath(report.url);
        if (historyPath) {
            let exact = self.reportsByPath[historyPath];
            if (exact) {
                return exact.length === 1 ? exact[0] : null;
            }

            // No exact hit: the stored url can carry extra leading segments (an api
            // version prefix, or a report server mounted under a sub-path). Both paths
            // keep their leading slash, so the suffix match is held to a segment
            // boundary - '/api/reports/x' cannot match '/api/reports/yx'.
            let suffix = [];
            Object.keys(self.reportsByPath).forEach(function (cataloguePath) {
                if (historyPath.length > cataloguePath.length
                    && historyPath.slice(-cataloguePath.length) === cataloguePath) {
                    suffix = suffix.concat(self.reportsByPath[cataloguePath]);
                }
            });
            if (suffix.length) {
                return suffix.length === 1 ? suffix[0] : null;
            }
        }

        let named = report.name ? self.reportsByName[report.name] : null;

        return named && named.length === 1 ? named[0] : null;
    }

    /**
     * Indexes the catalogue by url path and by name, so resolving a row is a lookup
     * rather than a scan.
     *
     * @remarks Rebuilt only when the catalogue reference itself changes. Without this,
     *     decorateReportsHistory() re-normalised every catalogue url once per row - at
     *     the 1000-rows page size that is 125,000 string rewrites per pass, and it runs
     *     again each time one of the three requests lands.
     * @remarks A path or name can legitimately map to several reports (R057 and URA3_
     *     share /api/reports/ura-report), so each key holds a list and the caller treats
     *     a list of more than one as unresolvable.
     * @returns {void}
     */
    setReportsIndex() {
        const self = this;

        if (self.reportsIndexedFrom === self.reports) {
            return;
        }

        self.reportsByPath = {};
        self.reportsByName = {};
        self.reportsIndexedFrom = self.reports;

        if (!self.reports) {
            return;
        }

        self.reports.forEach(function (catalogueReport) {
            let path = self.reportUrlPath(catalogueReport.url);
            if (path) {
                self.reportsByPath[path] = (self.reportsByPath[path] || []).concat(catalogueReport);
            }
            if (catalogueReport.name) {
                self.reportsByName[catalogueReport.name] =
                    (self.reportsByName[catalogueReport.name] || []).concat(catalogueReport);
            }
        });
    }

    /**
     * Path portion of a stored history url or a catalogue report url, normalised so the
     * two can be compared.
     *
     * Catalogue urls are bare paths and are not consistent about a leading slash
     * ('/api/reports/...' for report-server reports, 'sec/report/...' for old ones).
     * Stored history urls are those same paths behind an environment base, plus the
     * '?api_token=' query getApiURL() appends for is_old_report rows, and can carry a
     * doubled slash where the base already ended in one.
     *
     * @param {string} url A stored history url or a catalogue report url.
     * @returns {string} The path with a single leading slash and no trailing slash, or
     *     '' when there is nothing left to compare.
     */
    reportUrlPath(url) {
        if (!url) {
            return '';
        }

        let path = String(url).trim();

        path = path.split('#')[0].split('?')[0];
        path = path.replace(/^[a-z][a-z0-9+.\-]*:\/\/[^\/]*/i, ''); // scheme://host[:port]
        path = path.replace(/\/{2,}/g, '/');
        path = path.replace(/\/+$/, '');

        if (!path) {
            return '';
        }

        return path.charAt(0) === '/' ? path : '/' + path;
    }

    /**
     * The status list a report's Download popup offers.
     *
     * @remarks Mirrors the precedence in DeveloperReportsController.openDownloadReportModal()
     *     so the label comes from the same list the user picked from.
     * @param {Object|null} catalogueReport The row's resolved catalogue report.
     * @returns {Array|null} The status family, or null when the report offers no status.
     */
    getStatusFamily(catalogueReport) {
        const self = this;

        if (!catalogueReport) {
            return null;
        }
        if (catalogueReport.show_status == 1) {
            return self.allReportStatus;
        }
        if (catalogueReport.show_ura_status == 1) {
            return self.uraReportStatuses;
        }
        if (catalogueReport.show_option_issued_status == 1) {
            return self.optionIssuedReportStatuses;
        }

        return null;
    }

    /**
     * Label for the status a history row was generated with.
     *
     * @param {Object} report A report_histories row.
     * @param {Object|null} catalogueReport The row's resolved catalogue report.
     * @returns {string} The status label, or '' when the row has no status, the report
     *     offers no status selection, or the stored id is not one of the report's own -
     *     an empty string hides the line, which is better than a label borrowed from
     *     another status family.
     */
    getStatusLabel(report, catalogueReport) {
        const self = this;

        let status = report ? report.status : null;
        if (status === null || status === undefined || status === '') {
            return '';
        }

        // WEB-3328 SAGE exports share report_histories and are not filtered out of
        // sec/developer/reports-history, so their status is a word (generated /
        // regenerated / superseded) where every other row stores an id. Show it as-is.
        if (isNaN(status)) {
            return String(status);
        }

        let family = self.getStatusFamily(catalogueReport);
        if (!family) {
            // A resolved report that offers no status gets no line; a row whose report
            // could not be resolved at all falls back to the cross-family union so it
            // still shows something.
            return catalogueReport ? '' : self.getStatusLabelFromAnyFamily(status);
        }

        let match = family.find(function (option) {
            return option.id == status;
        });

        return match ? match.name : '';
    }

    /**
     * Status label looked up across all three families, for a row whose report cannot be
     * resolved in the catalogue at all.
     *
     * @remarks Built from the three families themselves so the two cannot drift apart.
     *     The ids they share (11 'All', 35 'OTP Aborted') carry the same label in each,
     *     so the union is unambiguous today; an id that ever disagreed across families
     *     is dropped rather than guessed.
     * @param {number|string} status The stored status id.
     * @returns {string} The label, or '' when no family claims the id unambiguously.
     */
    getStatusLabelFromAnyFamily(status) {
        const self = this;

        if (!self.anyStatusLabels) {
            let labels = {};

            [self.allReportStatus, self.uraReportStatuses, self.optionIssuedReportStatuses]
                .forEach(function (family) {
                    family.forEach(function (option) {
                        if (!labels.hasOwnProperty(option.id)) {
                            labels[option.id] = option.name;
                        } else if (labels[option.id] !== option.name) {
                            labels[option.id] = null; // Disagreement - do not guess.
                        }
                    });
                });

            self.anyStatusLabels = labels;
        }

        return self.anyStatusLabels[status] || '';
    }

    // write a function to get user display_name from self->users based on userId provided in parameter
    getUserDisplayName(userId) {
        const self = this;

        if (self.users) {
            let user = self.users.find(user => user.id === userId);

            return user ? user.display_name : '--';
        }

        return '--';
    }

    /**
     * Format a picked From/To filter date for the reports-history endpoint.
     *
     * WEB-4281: the server filters `created_at` by the calendar date it receives
     * (start/end of that day, no timezone conversion — see WEB-3838). The previous
     * `.utc()` conversion turned local midnight into the previous day's evening in
     * any zone ahead of UTC, so the whole filter window slid back one day. Send the
     * picked calendar date as-is, the same shape `reports.js` uses for report bounds.
     *
     * @param {string} localDate  Datepicker value in DD/MM/YYYY.
     * @returns {string|null|undefined}  YYYY-MM-DD, null if unparseable, undefined if empty.
     */
    toServerDate(localDate) {
        if (localDate) {
            let _date = moment(localDate, "DD/MM/YYYY");
            return _date._isValid ? _date.format("YYYY-MM-DD") : null;
        }
    }

    toLocalDate(utcDate) {
        if (utcDate) {
            let _date = moment.utc(utcDate, "YYYY-MM-DD HH:mm:ss");
            return _date._isValid ? _date.local().format("DD/MM/YYYY") : null;
        }
    }

    updateRowLimit() {
        const self = this;

        self.getReportHistory(1);
    }

    prepareHistoryPaginationData() {
        const self = this;

        self.total_count  = Math.ceil(self.total_count / self.filters.limit);

        self.historyPagesArrayDisplay = [];
        self.historyPagesArray = [];

        for (let i = 0; i < self.total_count; i++) {
            self.historyPagesArray.push(i + 1);
        }

        for (let i = self.pageNo - 3; i <= self.pageNo ; i++) {
            if(i <= 0 )
                continue;
            self.historyPagesArrayDisplay.push(i);
        }

        for (let j = self.pageNo + 1; j <= self.pageNo + 3; j++) {
            if(j > self.total_count)
                break;
            self.historyPagesArrayDisplay.push(j);
        }

        if (self.total_count < self.pageNo) {
            self.pageNo = 1;
        }
    }

    setPageHistory(pageNo) {
        const self = this;

        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.pageNo - 1;
            }

            if (pageNo > self.total_count) {
                pageNo = self.total_count;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.pageNo) {
                return; // Ignore if no change
            }

            self.pageNo = pageNo;
        }

        self.filters.offset = (self.pageNo - 1) * self.filters.limit;

        self.getReportHistory(self.pageNo);
    }

    clearFilters() {
        const self = this;

        self.initFilters();
        self.getReportHistory(self.pageNo);
    }

    initFilters()
    {
        const self = this;

        self.filters = {
            offset: 0,
            limit: 20,
            send_total_count: 1
        };

        self.pageNo = 1;
        self.current = 1;
    }

    getProperties() {
        const self = this;

        self.properties = [];
        let url = 'properties/customized';

        loading(true);
        self.SSHttpService.getAPIRequest(url,{offset:0,limit:1000,property_selected_fields : 'id,name'}).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.properties) {
                self.properties = response.data.properties;
                // self.$timeout(function() { $(".dashboard-select").niceSelect('update'); });

                self.decorateReportsHistory();
            }

        });
    }

    getPropertyName(property_id) {
        const self = this;

        if (property_id) {
            property_id = parseInt(property_id); // Convert to integer for comparison
        }

        if (self.properties) {
            let properties = self.properties.filter(function (property) {
                return property.id === property_id;
            });

            if (properties.length > 0)
                return properties[0].name;
        }
        return '--';
    }

    downloadReportHistory(report) {
        const self = this;

        // WEB-3591: report.url is an ABSOLUTE upstream URL stored when the
        // report was generated (older rows even have an api_token baked into
        // it). Rewrite it to the same-origin proxy path, which also drops any
        // stored token, so the download authenticates from the session instead
        // of putting a credential in the address bar.
        let url = self.SSHttpService.getProxyURLForUpstream(report.url);
        url += '&from_date=' + report.from_date;
        url += '&to_date=' + report.to_date;
        url += '&status=' + report.status;
        // WEB-4823: a law-firm-filtered row (e.g. R111) keeps its law firm; no filter = all law firms
        if (report.law_firm_id) {
            url += '&law_firm_id=' + report.law_firm_id;
        }

        if (report.allow_multiple_properties) {
            url += '&property_id=' + report.url_properties;
            window.open(encodeUrlWithParams(url), '_blank');
        } else {
            report.property_ids.forEach(function (value) {
                url += '&property_id=' + value;
                window.open(encodeUrlWithParams(url), '_blank');
            });
        }
    }
    
    downloadS3File(report){
        const self = this;

        let s3_url = null;
        if(!report.s3_file_url)
            return;
        s3_url = report.s3_file_url;

        let url = self.SSHttpService.getApiURL('sec/developer/reports-history/download-file?s3_file_url='+s3_url);

        window.open(url,'_blank');
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 10,
                name: 'View 10 Rows'
            },
            {
                id: 20,
                name: 'View 20 Rows'
            },
            {
                id: 50,
                name: 'View 50 Rows'
            },
            {
                id: 100,
                name: 'View 100 Rows'
            },
            {
                id: 1000,
                name: 'View 1000 Rows'
            }
        ];
    }

    getDeveloperUsers() {
        const self = this;

        self.users = null;

        let url = 'sec/developer/users';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data) {
                self.users = response.data.users;
               }

        });
    }

    getDeveloper() {
        const self = this;

        self.selectedDeveloper = null;

        let url = 'sec/developer/profile';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developer = response.data.developer;
        });
    }

}

DeveloperReportsHistoryController.$inject = ['$scope', '$timeout', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSDateService'];
app.controller('DeveloperReportsHistoryController', DeveloperReportsHistoryController);

